module.exports = __webpack_public_path__ + "static/jobs-statistics-382335138b0dc1f63084f91c07fad549.png";